import type { LinkProps, LinkTarget } from '@wix/editor-elements-definitions';
import { assert } from '../../../../common/sdk/assert';
import type { LinkUtils } from '@wix/thunderbolt-symbols';

export type PageList = Record<string, { title: string }>;

const externalRegex = /^(http|https):\/\/(.*)/;
const pageUrlRegex = /^\/([^ ?#]*)[?]?(.*)/;

export const isPageUrl = (url: string) => pageUrlRegex.test(url);
export const isExternalPage = (url: string) => externalRegex.test(url);

export const getLink = ({
  link,
  target,
  linkUtils,
}: {
  link?: string;
  target?: string;
  linkUtils: LinkUtils;
}): LinkProps => {
  if (!assert.isNil(link)) {
    const passedTarget = (target ||
      (isExternalPage(link) ? '_blank' : '_self')) as LinkTarget;
    return linkUtils.getLinkProps(link, passedTarget) as LinkProps;
  }

  return {};
};

const getPageTitleFromUrl = (
  url: string,
  pageList: PageList,
): string | undefined => {
  const key = url.slice(1);

  if (pageList.hasOwnProperty(key)) {
    return pageList[key]?.title;
  }

  return undefined;
};

export const getLabel = ({
  link,
  label,
  pageList,
}: {
  link?: string;
  label?: string;
  pageList: PageList;
}) => {
  if (!assert.isNil(label)) {
    return label;
  }

  if (!assert.isNil(link) && isPageUrl(link)) {
    return getPageTitleFromUrl(link, pageList);
  }

  return undefined;
};
